'use client';
export function nameToPath(name) {
  return name.includes('.') ? name.replace('.', '.object.') : name;
}